namespace $.$$ {
	$mol_style_define( $shm_surreal_table, {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 0,
		minHeight: 0,
		Toolbar: {
			flexWrap: 'wrap',
			alignItems: 'center',
		},
		Status: {
			color: $mol_theme.shade,
			padding: $mol_gap.text,
		},
		Grid: {
			flex: { grow: 1 },
			overflow: 'auto',
		},
		Footer: {
			alignItems: 'center',
			flexWrap: 'wrap',
		},
		Count: {
			padding: $mol_gap.text,
			color: $mol_theme.shade,
			flex: { grow: 1 },
		},
	} )
}
